module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured-posts border-bottom padding-bottom"
  }, [_c('div', {
    staticClass: "swiper-container padding-top",
    attrs: {
      "id": "featured-swiper-container"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.posts.featured), function(item) {
    return _c('dsFeaturedItem', {
      attrs: {
        "item": item,
        "language": _vm.language,
        "tags": _vm.tags
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-494ca472!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dsFeatured.vue
// module id = 217
// module chunks = 2